<span class="ant-table-row-indent" *ngIf="nzIndentSize >= 0" [style.padding-left.px]="nzIndentSize"></span>
<label *ngIf="nzShowCheckbox"
  nz-checkbox
  [nzDisabled]="nzDisabled"
  [(ngModel)]="nzChecked"
  [nzIndeterminate]="nzIndeterminate"
  (ngModelChange)="nzCheckedChange.emit($event)">
</label>
<span *ngIf="!nzShowExpand && nzIndentSize >= 0"
  class="ant-table-row-expand-icon ant-table-row-spaced">
</span>
<span *ngIf="nzShowExpand"
  class="ant-table-row-expand-icon"
  [class.ant-table-row-expanded]="nzExpand"
  [class.ant-table-row-collapsed]="!nzExpand"
  (click)="expandChange($event)">
</span>
<ng-content></ng-content>